"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getYoutubeEmbedLink(link) {
    const videoIdParse = link.match(/v=([^?&/]+)|.+\/([^&/?]+)$/);
    if (!videoIdParse)
        return '';
    const videoId = videoIdParse[1] || videoIdParse[2];
    return `https://www.youtube.com/embed/${videoId}`;
}
exports.default = getYoutubeEmbedLink;
